export const STATUS = {
  AGUARDANDO_APROVACAO: -1,
  INATIVO: 0,
  ATIVO: 1,
}
